import React from 'react';
import { LangProvider } from './LangContext';
import { Web3Provider } from './Web3Context';
import Navbar from './components/Navbar';


import Footer from './components/Footer';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Youtube from "./components/Youtube";
import Tiktok from "./components/Tiktok";
import Facebook from "./components/Facebook";
import Twitter from "./components/Twitter";
import Instagram from "./components/Instagram";
import Threads from "./components/Threads";
import Doodstream from "./components/Doodstream";


export default function App() {
  return (
		<BrowserRouter>
			<LangProvider>
			  <Web3Provider>
				<div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
				  <Navbar />
				  <main>
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/youtube-downloader" element={<Youtube />} />
						<Route path="/tiktok-downloader" element={<Tiktok />} />
						<Route path="/facebook-downloader" element={<Facebook />} />
						<Route path="/twitter-downloader" element={<Twitter />} />
						<Route path="/instagram-downloader" element={<Instagram />} />
						<Route path="/threads-downloader" element={<Threads />} />
						<Route path="/doodstream-downloader" element={<Doodstream />} />
					</Routes>

				  </main>
				  <Footer />
				</div>
			  </Web3Provider>
			</LangProvider>
		</BrowserRouter>
  );
}
